import React from "react";

const EmphasisText = ({ text }) => {
  const parts = String(text).split(/\{em\}|\{\/em\}/);
  return parts.map((part, index) =>
    index % 2 === 1 ? <em key={index}>{part}</em> : part
  );
};

export default EmphasisText;
